<template>
  <section>
    <!--工具条-->
    <CustomFeaturePointsToolbar :buttonList="buttonList" @callFunction="callFunction"></CustomFeaturePointsToolbar>

    <!--列表-->
    <el-table :data="customFeaturePointsList" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="100"></el-table-column>
      <el-table-column prop="CustomName" label="客户名称" width="230" sortable></el-table-column>
      <el-table-column prop="FeatureName" label="图元名称" width="230" sortable></el-table-column>
      <el-table-column prop="Numbering" label="坐标点顺序号" width="230" sortable></el-table-column>
      <el-table-column prop="Longitude" label="经度" width="230" sortable></el-table-column>
      <el-table-column prop="Latitude" label="纬度" width="230" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getCustomFeaturePointsListPage } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import CustomFeaturePointsToolbar from "../../components/QueryToolbar/CustomFeaturePointsToolbar";

export default {
  components: { CustomFeaturePointsToolbar },
  data() {
    return {
      filters: {
        customerId: "",
      },
      buttonList: [],
      operationButtonList: [],
      customFeaturePointsList: [], //客户电子围栏经纬度列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customerId: item.customerId,
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getVehicleInfo();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCustomFeaturePoints();
    },
    queryCustomFeaturePoints() {
      this.page = 1;
      this.getCustomFeaturePoints();
    },
    //获取车辆列表
    getCustomFeaturePoints() {
      let _this = this;
      let para = {
        customerId: _this.filters.customerId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getCustomFeaturePointsListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.customFeaturePointsList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getCustomFeaturePoints();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
